import { ReactNode } from "react";
import { buildClasses } from "../utils/buildClasses";
import { RyeIcon } from "./RyeIcon";

/**
 * What a view shows when there's data, just none matching, such as a date
 * range or filters that leave nothing. Quieter than RyeEmptyState, which is for
 * a screen that hasn't been set up yet: a short title, why, and optionally a
 * way out. Centered in its container.
 */
export function RyeNoResults({
  icon = "search_off",
  title,
  description,
  action,
}: {
  icon?: string;
  title: string;
  /** Why there's nothing, in a sentence. */
  description: ReactNode;
  /** A way to see something, such as clearing filters. */
  action?: ReactNode;
}): JSX.Element {
  return (
    <div
      className={buildClasses(
        "flex",
        "h-full",
        "min-h-[16rem]",
        "flex-col",
        "items-center",
        "justify-center",
        "gap-2",
        "px-4",
        "text-center",
      )}
    >
      <RyeIcon
        name={icon}
        size="lg"
        className={buildClasses("text-on-surface-400")}
      />
      <span className={buildClasses("text-lg", "text-on-surface-700")}>
        {title}
      </span>
      <span
        className={buildClasses(
          "max-w-md",
          "text-sm",
          "text-on-surface-500",
          "text-pretty",
        )}
      >
        {description}
      </span>
      {action && <div className={buildClasses("mt-2")}>{action}</div>}
    </div>
  );
}
